import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/getByDocId`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId/comments`;

type GetFileCommentsResponse = {
  data: any;
  status: boolean;
};

export const getFileComments = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
}): Promise<GetFileCommentsResponse> => {
  return axios.get(
    generateRoutePath(url, {
      projectId: projectId,
      inboxEntryId: inboxEntryId,
      emailId: emailId,
      fileId: fileId,
    })
  );
};

export const emailFileCommentsKeys = {
  all: ['fileComments'] as const,
  detail: ({
    projectId,
    fileId,
    emailId,
    inboxEntryId,
  }: {
    projectId: string;
    fileId: number;
    emailId: number;
    inboxEntryId: number;
  }) =>
    [
      INBOX_API_KEY,
      ...emailFileCommentsKeys.all,
      projectId,
      fileId,
      { emailId, inboxEntryId },
    ] as const,
};

type QueryFnType = typeof getFileComments;

type useEmailFileCommentsOptions = {
  projectId: string;
  fileId: number;
  inboxEntryId: number;
  emailId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEmailFileComments = ({
  projectId,
  fileId,
  config,
  ...otherParams
}: useEmailFileCommentsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailFileCommentsKeys.all, projectId, fileId, otherParams],
    queryFn: () => getFileComments({ projectId, fileId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
